/**
 * Which Deeliver categories the staging pages offer as a "Deeliver App Category".
 *
 * `/staging/category-mappings/local` returns every non-hidden row of `category`, which
 * includes categories switched off in Content Control (Archive, Beverages, Liquor) and the
 * New & Popular home tile, which is a filter rather than a shop category. Only categories
 * that are switched on and hold products in the app are a sensible target for a Vend type
 * (Jason, 24 Oct 2026). The Default Category picker keeps its own, looser rule
 * (`isAssignableCategory` in VaperiteCategoryMappings), which allows New & Popular.
 */
export interface AppCategoryCandidate {
  id: string;
  name: string;
  isActive: boolean;
  homeFilterType?: string | null;
}

export const isAppCategory = (c: AppCategoryCandidate): boolean =>
  c.isActive && (c.homeFilterType ?? 'category') === 'category';

/**
 * The app categories, plus `keepId` when it falls outside them, so editing a mapping that
 * points at a category since switched off shows that category instead of a blank select.
 */
export function appCategoryOptions<T extends AppCategoryCandidate>(all: T[], keepId?: string | null): T[] {
  return all.filter((c) => isAppCategory(c) || (keepId != null && c.id === keepId));
}
